import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
import sysUtils from 'utils/ShopYourStore';
const { wrapHOC } = FrameworkUtils;

const fields = createSelector(
    (_state, ownProps) => ownProps.showUpperFunnelChiclets,
    (_state, ownProps) => ownProps.forceUpperFunnelChiclets,
    (showUpperFunnelChiclets, forceUpperFunnelChiclets) => {
        const isShopYourStoreFilterEnabled = sysUtils.shopYourStoreFilterEnabled();

        return {
            showUpperFunnelChiclets: forceUpperFunnelChiclets || (showUpperFunnelChiclets && isShopYourStoreFilterEnabled)
        };
    }
);

const withFilterChicletsProps = wrapHOC(connect(fields));

export {
    fields, withFilterChicletsProps
};
